export interface CopyReadyPostInput {
  title?: string | null;
  dateTimeText?: string | null;
  priceText?: string | null;
  body?: string | null;
  link?: string | null;
}

function clean(value: string | null | undefined): string {
  return (value || '').trim();
}

export function formatPriceSek(priceOre: number | null | undefined): string | null {
  if (priceOre == null || Number.isNaN(priceOre)) return null;
  const sek = priceOre / 100;
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 }).format(sek);
}

export function buildCopyReadyPost(input: CopyReadyPostInput): string {
  const lines: string[] = [];

  const title = clean(input.title);
  if (title) lines.push(title);

  const meta: string[] = [];
  const dateTimeText = clean(input.dateTimeText);
  if (dateTimeText) meta.push(`📅 ${dateTimeText}`);

  const priceText = clean(input.priceText);
  if (priceText) meta.push(`💰 ${priceText}`);

  if (meta.length > 0) {
    lines.push(meta.join('\n'));
  }

  const body = clean(input.body);
  if (body) lines.push(body);

  const link = clean(input.link);
  if (link) {
    lines.push(`Läs mer:\n${link}`);
  }

  return lines.join('\n\n').trim();
}
